exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-echarts[data-v-16d1ed91] {\n    width: 100%;\n    height: 100%;\n}\n", ""]);

// exports
